// Data Simulator variable definitions for variable autocomplete dropdown
// Reference: Test Executor Mock Methods v3.3 (January 2026)
// All mock methods are case-insensitive and resolved at runtime

export const MOCK_DATA_VARIABLES = [
  // ─── Null & Empty Values ───────────────────────────────────────────
  {
    name: 'null',
    reference: 'mock.null',
    category: 'mock',
    subCategory: 'Null & Empty Values',
    description: 'Generate a null value'
  },
  {
    name: 'empty',
    reference: 'mock.empty',
    category: 'mock',
    subCategory: 'Null & Empty Values',
    description: 'Generate an empty string'
  },
  {
    name: 'empty_string',
    reference: 'mock.empty_string',
    category: 'mock',
    subCategory: 'Null & Empty Values',
    description: 'Generate an empty string (alias)'
  },
  {
    name: 'whitespace',
    reference: 'mock.whitespace',
    category: 'mock',
    subCategory: 'Null & Empty Values',
    description: 'Generate a single space'
  },
  {
    name: 'whitespace_multiple',
    reference: 'mock.whitespace_multiple',
    category: 'mock',
    subCategory: 'Null & Empty Values',
    description: 'Generate multiple spaces'
  },
  {
    name: 'blank',
    reference: 'mock.blank',
    category: 'mock',
    subCategory: 'Null & Empty Values',
    description: 'Generate an empty string (alias)'
  },

  // ─── Personal & Identity ───────────────────────────────────────────
  {
    name: 'firstname',
    reference: 'mock.firstname',
    category: 'mock',
    subCategory: 'Personal & Identity',
    description: 'Generate a random first name'
  },
  {
    name: 'lastname',
    reference: 'mock.lastname',
    category: 'mock',
    subCategory: 'Personal & Identity',
    description: 'Generate a random last name'
  },
  {
    name: 'fullname',
    reference: 'mock.fullname',
    category: 'mock',
    subCategory: 'Personal & Identity',
    description: 'Generate a random full name'
  },
  {
    name: 'username',
    reference: 'mock.username',
    category: 'mock',
    subCategory: 'Personal & Identity',
    description: 'Generate a random username'
  },
  {
    name: 'email',
    reference: 'mock.email',
    category: 'mock',
    subCategory: 'Personal & Identity',
    description: 'Generate a random email address'
  },
  {
    name: 'email_testing_randomnumber',
    reference: 'mock.email_testing_randomnumber',
    category: 'mock',
    subCategory: 'Personal & Identity',
    description: 'Generate testing email with random number in domain'
  },
  {
    name: 'email_testing_randomname',
    reference: 'mock.email_testing_randomname',
    category: 'mock',
    subCategory: 'Personal & Identity',
    description: 'Generate testing email with random name in domain'
  },
  {
    name: 'email_custom_randomnumber',
    reference: 'mock.email_custom_randomnumber',
    category: 'mock',
    subCategory: 'Personal & Identity',
    description: 'Generate custom email with random number in domain'
  },
  {
    name: 'email_custom_randomname',
    reference: 'mock.email_custom_randomname',
    category: 'mock',
    subCategory: 'Personal & Identity',
    description: 'Generate custom email with random name in domain'
  },
  {
    name: 'password',
    reference: 'mock.password',
    category: 'mock',
    subCategory: 'Personal & Identity',
    description: 'Generate a random password'
  },
  {
    name: 'phone',
    reference: 'mock.phone',
    category: 'mock',
    subCategory: 'Personal & Identity',
    description: 'Generate a random phone number'
  },
  {
    name: 'cellphone',
    reference: 'mock.cellphone',
    category: 'mock',
    subCategory: 'Personal & Identity',
    description: 'Generate a random cell phone number'
  },

  // ─── Address & Location ────────────────────────────────────────────
  {
    name: 'address',
    reference: 'mock.address',
    category: 'mock',
    subCategory: 'Address & Location',
    description: 'Generate a full address'
  },
  {
    name: 'streetaddress',
    reference: 'mock.streetaddress',
    category: 'mock',
    subCategory: 'Address & Location',
    description: 'Generate a street address'
  },
  {
    name: 'streetname',
    reference: 'mock.streetname',
    category: 'mock',
    subCategory: 'Address & Location',
    description: 'Generate a street name'
  },
  {
    name: 'city',
    reference: 'mock.city',
    category: 'mock',
    subCategory: 'Address & Location',
    description: 'Generate a random city name'
  },
  {
    name: 'state',
    reference: 'mock.state',
    category: 'mock',
    subCategory: 'Address & Location',
    description: 'Generate a random state/province'
  },
  {
    name: 'country',
    reference: 'mock.country',
    category: 'mock',
    subCategory: 'Address & Location',
    description: 'Generate a random country name'
  },
  {
    name: 'zipcode',
    reference: 'mock.zipcode',
    category: 'mock',
    subCategory: 'Address & Location',
    description: 'Generate a random ZIP/postal code'
  },
  {
    name: 'latitude',
    reference: 'mock.latitude',
    category: 'mock',
    subCategory: 'Address & Location',
    description: 'Generate a random latitude coordinate'
  },
  {
    name: 'longitude',
    reference: 'mock.longitude',
    category: 'mock',
    subCategory: 'Address & Location',
    description: 'Generate a random longitude coordinate'
  },

  // ─── Financial & Commerce ──────────────────────────────────────────
  {
    name: 'creditcard',
    reference: 'mock.creditcard',
    category: 'mock',
    subCategory: 'Financial & Commerce',
    description: 'Generate a credit card number'
  },
  {
    name: 'iban',
    reference: 'mock.iban',
    category: 'mock',
    subCategory: 'Financial & Commerce',
    description: 'Generate a random IBAN number'
  },
  {
    name: 'bic',
    reference: 'mock.bic',
    category: 'mock',
    subCategory: 'Financial & Commerce',
    description: 'Generate a random BIC/SWIFT code'
  },
  {
    name: 'productname',
    reference: 'mock.productname',
    category: 'mock',
    subCategory: 'Financial & Commerce',
    description: 'Generate a product name'
  },
  {
    name: 'price',
    reference: 'mock.price',
    category: 'mock',
    subCategory: 'Financial & Commerce',
    description: 'Generate a random price'
  },
  {
    name: 'department',
    reference: 'mock.department',
    category: 'mock',
    subCategory: 'Financial & Commerce',
    description: 'Generate a department name'
  },
  {
    name: 'material',
    reference: 'mock.material',
    category: 'mock',
    subCategory: 'Financial & Commerce',
    description: 'Generate a material name'
  },

  // ─── Company & Business ────────────────────────────────────────────
  {
    name: 'company',
    reference: 'mock.company',
    category: 'mock',
    subCategory: 'Company & Business',
    description: 'Generate a random company name'
  },
  {
    name: 'companysuffix',
    reference: 'mock.companysuffix',
    category: 'mock',
    subCategory: 'Company & Business',
    description: 'Generate a company suffix (Inc., LLC, etc.)'
  },
  {
    name: 'industry',
    reference: 'mock.industry',
    category: 'mock',
    subCategory: 'Company & Business',
    description: 'Generate an industry name'
  },
  {
    name: 'profession',
    reference: 'mock.profession',
    category: 'mock',
    subCategory: 'Company & Business',
    description: 'Generate a profession'
  },
  {
    name: 'jobtitle',
    reference: 'mock.jobtitle',
    category: 'mock',
    subCategory: 'Company & Business',
    description: 'Generate a random job title'
  },
  {
    name: 'jobfield',
    reference: 'mock.jobfield',
    category: 'mock',
    subCategory: 'Company & Business',
    description: 'Generate a job field'
  },
  {
    name: 'jobkeyskills',
    reference: 'mock.jobkeyskills',
    category: 'mock',
    subCategory: 'Company & Business',
    description: 'Generate job key skills'
  },

  // ─── Internet & Technology ─────────────────────────────────────────
  {
    name: 'domain',
    reference: 'mock.domain',
    category: 'mock',
    subCategory: 'Internet & Technology',
    description: 'Generate a domain name'
  },
  {
    name: 'url',
    reference: 'mock.url',
    category: 'mock',
    subCategory: 'Internet & Technology',
    description: 'Generate a random URL'
  },
  {
    name: 'ipaddress',
    reference: 'mock.ipaddress',
    category: 'mock',
    subCategory: 'Internet & Technology',
    description: 'Generate an IPv4 address'
  },
  {
    name: 'macaddress',
    reference: 'mock.macaddress',
    category: 'mock',
    subCategory: 'Internet & Technology',
    description: 'Generate a MAC address'
  },
  {
    name: 'slug',
    reference: 'mock.slug',
    category: 'mock',
    subCategory: 'Internet & Technology',
    description: 'Generate a URL slug'
  },

  // ─── Text & Content ────────────────────────────────────────────────
  {
    name: 'sentence',
    reference: 'mock.sentence',
    category: 'mock',
    subCategory: 'Text & Content',
    description: 'Generate a random sentence'
  },
  {
    name: 'paragraph',
    reference: 'mock.paragraph',
    category: 'mock',
    subCategory: 'Text & Content',
    description: 'Generate a random paragraph'
  },
  {
    name: 'word',
    reference: 'mock.word',
    category: 'mock',
    subCategory: 'Text & Content',
    description: 'Generate a random word'
  },
  {
    name: 'booktitle',
    reference: 'mock.booktitle',
    category: 'mock',
    subCategory: 'Text & Content',
    description: 'Generate a book title'
  },
  {
    name: 'bookauthor',
    reference: 'mock.bookauthor',
    category: 'mock',
    subCategory: 'Text & Content',
    description: 'Generate a book author'
  },
  {
    name: 'bookpublisher',
    reference: 'mock.bookpublisher',
    category: 'mock',
    subCategory: 'Text & Content',
    description: 'Generate a publisher name'
  },

  // ─── Numbers & Identifiers ─────────────────────────────────────────
  {
    name: 'randomint',
    reference: 'mock.randomint',
    category: 'mock',
    subCategory: 'Numbers & Identifiers',
    description: 'Generate a random integer'
  },
  {
    name: 'randomdigits',
    reference: 'mock.randomdigits',
    category: 'mock',
    subCategory: 'Numbers & Identifiers',
    description: 'Generate 10 random digits'
  },
  {
    name: 'uuid',
    reference: 'mock.uuid',
    category: 'mock',
    subCategory: 'Numbers & Identifiers',
    description: 'Generate a UUID (v4)'
  },

  // ─── OTP (One-Time Password) ───────────────────────────────────────
  {
    name: 'otp',
    reference: 'mock.otp',
    category: 'mock',
    subCategory: 'OTP (One-Time Password)',
    description: 'Generate a 6-digit OTP (default)'
  },
  {
    name: 'otp_6',
    reference: 'mock.otp_6',
    category: 'mock',
    subCategory: 'OTP (One-Time Password)',
    description: 'Generate a 6-digit OTP'
  },
  {
    name: 'otp_6digit',
    reference: 'mock.otp_6digit',
    category: 'mock',
    subCategory: 'OTP (One-Time Password)',
    description: 'Generate a 6-digit OTP (alias)'
  },
  {
    name: 'otp_4',
    reference: 'mock.otp_4',
    category: 'mock',
    subCategory: 'OTP (One-Time Password)',
    description: 'Generate a 4-digit OTP'
  },
  {
    name: 'otp_4digit',
    reference: 'mock.otp_4digit',
    category: 'mock',
    subCategory: 'OTP (One-Time Password)',
    description: 'Generate a 4-digit OTP (alias)'
  },
  {
    name: 'otp_8',
    reference: 'mock.otp_8',
    category: 'mock',
    subCategory: 'OTP (One-Time Password)',
    description: 'Generate an 8-digit OTP'
  },
  {
    name: 'otp_8digit',
    reference: 'mock.otp_8digit',
    category: 'mock',
    subCategory: 'OTP (One-Time Password)',
    description: 'Generate an 8-digit OTP (alias)'
  },
  {
    name: 'otp_static',
    reference: 'mock.otp_static',
    category: 'mock',
    subCategory: 'OTP (One-Time Password)',
    description: 'Generate static OTP for testing (000000)'
  },
  {
    name: 'otp_000000',
    reference: 'mock.otp_000000',
    category: 'mock',
    subCategory: 'OTP (One-Time Password)',
    description: 'Generate static OTP (alias)'
  },
  {
    name: 'otp_zeros',
    reference: 'mock.otp_zeros',
    category: 'mock',
    subCategory: 'OTP (One-Time Password)',
    description: 'Generate static OTP (alias)'
  },

  // ─── Random Strings ────────────────────────────────────────────────
  {
    name: 'randomstring',
    reference: 'mock.randomstring',
    category: 'mock',
    subCategory: 'Random Strings',
    description: 'Generate 10 random characters'
  },
  {
    name: 'randomstring_short',
    reference: 'mock.randomstring_short',
    category: 'mock',
    subCategory: 'Random Strings',
    description: 'Generate 5 random characters'
  },
  {
    name: 'randomstring_long',
    reference: 'mock.randomstring_long',
    category: 'mock',
    subCategory: 'Random Strings',
    description: 'Generate 20 random characters'
  },
  {
    name: 'randomstring_alphanumeric',
    reference: 'mock.randomstring_alphanumeric',
    category: 'mock',
    subCategory: 'Random Strings',
    description: 'Generate 10 alphanumeric characters'
  },
  {
    name: 'randomstring_letters',
    reference: 'mock.randomstring_letters',
    category: 'mock',
    subCategory: 'Random Strings',
    description: 'Generate 10 letters only'
  },
  {
    name: 'randomstring_uppercase',
    reference: 'mock.randomstring_uppercase',
    category: 'mock',
    subCategory: 'Random Strings',
    description: 'Generate 8 uppercase letters'
  },
  {
    name: 'randomstring_lowercase',
    reference: 'mock.randomstring_lowercase',
    category: 'mock',
    subCategory: 'Random Strings',
    description: 'Generate 8 lowercase letters'
  },
  {
    name: 'randomstring_numbers',
    reference: 'mock.randomstring_numbers',
    category: 'mock',
    subCategory: 'Random Strings',
    description: 'Generate 8 numbers only'
  },
  {
    name: 'randomstring_custom',
    reference: 'mock.randomstring_custom',
    category: 'mock',
    subCategory: 'Random Strings',
    description: 'Generate custom pattern: AA1234bb'
  },

  // ─── Entertainment & Pop Culture ───────────────────────────────────
  {
    name: 'gameofthrones',
    reference: 'mock.gameofthrones',
    category: 'mock',
    subCategory: 'Entertainment & Pop Culture',
    description: 'Generate a Game of Thrones character'
  },
  {
    name: 'harrypotter',
    reference: 'mock.harrypotter',
    category: 'mock',
    subCategory: 'Entertainment & Pop Culture',
    description: 'Generate a Harry Potter character'
  },
  {
    name: 'lordoftherings',
    reference: 'mock.lordoftherings',
    category: 'mock',
    subCategory: 'Entertainment & Pop Culture',
    description: 'Generate a Lord of the Rings character'
  },
  {
    name: 'starwars',
    reference: 'mock.starwars',
    category: 'mock',
    subCategory: 'Entertainment & Pop Culture',
    description: 'Generate a Star Wars character'
  },
  {
    name: 'pokemon',
    reference: 'mock.pokemon',
    category: 'mock',
    subCategory: 'Entertainment & Pop Culture',
    description: 'Generate a Pokemon name'
  },
  {
    name: 'superhero',
    reference: 'mock.superhero',
    category: 'mock',
    subCategory: 'Entertainment & Pop Culture',
    description: 'Generate a superhero name'
  },
  {
    name: 'chucknorris',
    reference: 'mock.chucknorris',
    category: 'mock',
    subCategory: 'Entertainment & Pop Culture',
    description: 'Generate a Chuck Norris fact'
  },
  {
    name: 'shakespeare',
    reference: 'mock.shakespeare',
    category: 'mock',
    subCategory: 'Entertainment & Pop Culture',
    description: 'Generate a Shakespeare quote'
  },

  // ─── Animals & Nature ──────────────────────────────────────────────
  {
    name: 'animal',
    reference: 'mock.animal',
    category: 'mock',
    subCategory: 'Animals & Nature',
    description: 'Generate a random animal name'
  },
  {
    name: 'cat',
    reference: 'mock.cat',
    category: 'mock',
    subCategory: 'Animals & Nature',
    description: 'Generate a cat breed'
  },
  {
    name: 'dog',
    reference: 'mock.dog',
    category: 'mock',
    subCategory: 'Animals & Nature',
    description: 'Generate a dog breed'
  },
  {
    name: 'color_name',
    reference: 'mock.color_name',
    category: 'mock',
    subCategory: 'Animals & Nature',
    description: 'Generate a color name'
  },

  // ─── Food & Drink ──────────────────────────────────────────────────
  {
    name: 'food',
    reference: 'mock.food',
    category: 'mock',
    subCategory: 'Food & Drink',
    description: 'Generate a food ingredient'
  },
  {
    name: 'beer',
    reference: 'mock.beer',
    category: 'mock',
    subCategory: 'Food & Drink',
    description: 'Generate a beer name'
  },

  // ─── Education ─────────────────────────────────────────────────────
  {
    name: 'university',
    reference: 'mock.university',
    category: 'mock',
    subCategory: 'Education',
    description: 'Generate a university name'
  },
  {
    name: 'course',
    reference: 'mock.course',
    category: 'mock',
    subCategory: 'Education',
    description: 'Generate a course name'
  },

  // ─── Geography & Weather ───────────────────────────────────────────
  {
    name: 'weather',
    reference: 'mock.weather',
    category: 'mock',
    subCategory: 'Geography & Weather',
    description: 'Generate a weather description'
  },

  // ─── Technology & Hacking ──────────────────────────────────────────
  {
    name: 'hacker_noun',
    reference: 'mock.hacker_noun',
    category: 'mock',
    subCategory: 'Technology & Hacking',
    description: 'Generate a hacker noun'
  },
  {
    name: 'hacker_verb',
    reference: 'mock.hacker_verb',
    category: 'mock',
    subCategory: 'Technology & Hacking',
    description: 'Generate a hacker verb'
  },
  {
    name: 'programming_language',
    reference: 'mock.programming_language',
    category: 'mock',
    subCategory: 'Technology & Hacking',
    description: 'Generate a programming language'
  },

  // ─── Files & Systems ───────────────────────────────────────────────
  {
    name: 'filename',
    reference: 'mock.filename',
    category: 'mock',
    subCategory: 'Files & Systems',
    description: 'Generate a file name'
  },
  {
    name: 'file_extension',
    reference: 'mock.file_extension',
    category: 'mock',
    subCategory: 'Files & Systems',
    description: 'Generate a file extension'
  },
  {
    name: 'mime_type',
    reference: 'mock.mime_type',
    category: 'mock',
    subCategory: 'Files & Systems',
    description: 'Generate a MIME type'
  },

  // ─── Sports & Games ────────────────────────────────────────────────
  {
    name: 'team',
    reference: 'mock.team',
    category: 'mock',
    subCategory: 'Sports & Games',
    description: 'Generate a team name'
  },
  {
    name: 'sport',
    reference: 'mock.sport',
    category: 'mock',
    subCategory: 'Sports & Games',
    description: 'Generate a sport name'
  },
  {
    name: 'esports',
    reference: 'mock.esports',
    category: 'mock',
    subCategory: 'Sports & Games',
    description: 'Generate an esports game'
  },

  // ─── Transportation ────────────────────────────────────────────────
  {
    name: 'aviation_aircraft',
    reference: 'mock.aviation_aircraft',
    category: 'mock',
    subCategory: 'Transportation',
    description: 'Generate an aircraft name'
  },
  {
    name: 'aviation_airport',
    reference: 'mock.aviation_airport',
    category: 'mock',
    subCategory: 'Transportation',
    description: 'Generate an airport name'
  },

  // ─── Music & Art ───────────────────────────────────────────────────
  {
    name: 'music_instrument',
    reference: 'mock.music_instrument',
    category: 'mock',
    subCategory: 'Music & Art',
    description: 'Generate a musical instrument'
  },
  {
    name: 'artist',
    reference: 'mock.artist',
    category: 'mock',
    subCategory: 'Music & Art',
    description: 'Generate an artist name'
  },
  {
    name: 'music_key',
    reference: 'mock.music_key',
    category: 'mock',
    subCategory: 'Music & Art',
    description: 'Generate a musical key'
  },

  // ─── Localized Data ────────────────────────────────────────────────
  {
    name: 'german_name',
    reference: 'mock.german_name',
    category: 'mock',
    subCategory: 'Localized Data',
    description: 'Generate a German name'
  },
  {
    name: 'french_name',
    reference: 'mock.french_name',
    category: 'mock',
    subCategory: 'Localized Data',
    description: 'Generate a French name'
  },
  {
    name: 'japanese_name',
    reference: 'mock.japanese_name',
    category: 'mock',
    subCategory: 'Localized Data',
    description: 'Generate a Japanese name'
  },
  {
    name: 'spanish_address',
    reference: 'mock.spanish_address',
    category: 'mock',
    subCategory: 'Localized Data',
    description: 'Generate a Spanish address'
  },

  // ─── Custom Patterns ───────────────────────────────────────────────
  {
    name: 'letterify',
    reference: 'mock.letterify',
    category: 'mock',
    subCategory: 'Custom Patterns',
    description: 'Generate 4 random letters'
  },
  {
    name: 'numerify',
    reference: 'mock.numerify',
    category: 'mock',
    subCategory: 'Custom Patterns',
    description: 'Generate 4 random digits'
  },
  {
    name: 'bothify',
    reference: 'mock.bothify',
    category: 'mock',
    subCategory: 'Custom Patterns',
    description: 'Generate 2 letters + 2 digits'
  },
  {
    name: 'regexify',
    reference: 'mock.regexify',
    category: 'mock',
    subCategory: 'Custom Patterns',
    description: 'Generate 4-10 lowercase letters'
  },

  // ─── Date & Time ───────────────────────────────────────────────────
  {
    name: 'date_dd_mm_yyyy',
    reference: 'mock.date_dd_mm_yyyy',
    category: 'mock',
    subCategory: 'Date & Time',
    description: 'Generate date in DD/MM/YYYY format'
  },
  {
    name: 'date_mm_dd_yyyy',
    reference: 'mock.date_mm_dd_yyyy',
    category: 'mock',
    subCategory: 'Date & Time',
    description: 'Generate date in MM/DD/YYYY format'
  },
  {
    name: 'date_yyyy_mm_dd',
    reference: 'mock.date_yyyy_mm_dd',
    category: 'mock',
    subCategory: 'Date & Time',
    description: 'Generate date in YYYY-MM-DD format'
  },
  {
    name: 'time_24h',
    reference: 'mock.time_24h',
    category: 'mock',
    subCategory: 'Date & Time',
    description: 'Generate time in 24-hour format'
  },
  {
    name: 'time_12h',
    reference: 'mock.time_12h',
    category: 'mock',
    subCategory: 'Date & Time',
    description: 'Generate time in 12-hour format'
  },
  {
    name: 'timestamp_unix',
    reference: 'mock.timestamp_unix',
    category: 'mock',
    subCategory: 'Date & Time',
    description: 'Generate Unix timestamp (seconds)'
  },
  {
    name: 'timestamp_millis',
    reference: 'mock.timestamp_millis',
    category: 'mock',
    subCategory: 'Date & Time',
    description: 'Generate timestamp in milliseconds'
  },
  {
    name: 'timestamp_iso',
    reference: 'mock.timestamp_iso',
    category: 'mock',
    subCategory: 'Date & Time',
    description: 'Generate ISO 8601 timestamp with timezone'
  },
  {
    name: 'timestamp_iso8601',
    reference: 'mock.timestamp_iso8601',
    category: 'mock',
    subCategory: 'Date & Time',
    description: 'Generate ISO 8601 timestamp (alias)'
  },
  {
    name: 'datetime_iso',
    reference: 'mock.datetime_iso',
    category: 'mock',
    subCategory: 'Date & Time',
    description: 'Generate ISO 8601 timestamp (alias)'
  },
  {
    name: 'timestamp_iso_local',
    reference: 'mock.timestamp_iso_local',
    category: 'mock',
    subCategory: 'Date & Time',
    description: 'Generate ISO 8601 without timezone'
  },
  {
    name: 'datetime_iso_local',
    reference: 'mock.datetime_iso_local',
    category: 'mock',
    subCategory: 'Date & Time',
    description: 'Generate ISO 8601 local (alias)'
  },

  // ─── Boolean & Options ─────────────────────────────────────────────
  {
    name: 'boolean',
    reference: 'mock.boolean',
    category: 'mock',
    subCategory: 'Boolean & Options',
    description: 'Generate a boolean value (true/false)'
  },

  // ─── Currency ──────────────────────────────────────────────────────
  {
    name: 'currency_zar',
    reference: 'mock.currency_zar',
    category: 'mock',
    subCategory: 'Currency',
    description: 'Generate price in South African Rand'
  },
  {
    name: 'currency_rand',
    reference: 'mock.currency_rand',
    category: 'mock',
    subCategory: 'Currency',
    description: 'Generate price in Rand (alias)'
  },
  {
    name: 'currency_usd',
    reference: 'mock.currency_usd',
    category: 'mock',
    subCategory: 'Currency',
    description: 'Generate price in US Dollar'
  },
  {
    name: 'currency_eur',
    reference: 'mock.currency_eur',
    category: 'mock',
    subCategory: 'Currency',
    description: 'Generate price in Euro'
  },
  {
    name: 'currency_gbp',
    reference: 'mock.currency_gbp',
    category: 'mock',
    subCategory: 'Currency',
    description: 'Generate price in British Pound'
  },
  {
    name: 'currency_code_za',
    reference: 'mock.currency_code_za',
    category: 'mock',
    subCategory: 'Currency',
    description: 'Return ZAR currency code'
  },
  {
    name: 'currency_code_us',
    reference: 'mock.currency_code_us',
    category: 'mock',
    subCategory: 'Currency',
    description: 'Return USD currency code'
  },
  {
    name: 'currency_code_eu',
    reference: 'mock.currency_code_eu',
    category: 'mock',
    subCategory: 'Currency',
    description: 'Return EUR currency code'
  },
  {
    name: 'currency_code_gb',
    reference: 'mock.currency_code_gb',
    category: 'mock',
    subCategory: 'Currency',
    description: 'Return GBP currency code'
  },
  {
    name: 'currency_symbol_za',
    reference: 'mock.currency_symbol_za',
    category: 'mock',
    subCategory: 'Currency',
    description: 'Return ZAR currency symbol (R)'
  },
  {
    name: 'currency_symbol_us',
    reference: 'mock.currency_symbol_us',
    category: 'mock',
    subCategory: 'Currency',
    description: 'Return USD currency symbol ($)'
  },
  {
    name: 'currency_symbol_eu',
    reference: 'mock.currency_symbol_eu',
    category: 'mock',
    subCategory: 'Currency',
    description: 'Return EUR currency symbol (€)'
  },
  {
    name: 'currency_symbol_gb',
    reference: 'mock.currency_symbol_gb',
    category: 'mock',
    subCategory: 'Currency',
    description: 'Return GBP currency symbol (£)'
  },

  // ─── Units of Measurement ──────────────────────────────────────────
  {
    name: 'unit_distance_metric',
    reference: 'mock.unit_distance_metric',
    category: 'mock',
    subCategory: 'Units of Measurement',
    description: 'Generate distance in kilometers'
  },
  {
    name: 'unit_distance_imperial',
    reference: 'mock.unit_distance_imperial',
    category: 'mock',
    subCategory: 'Units of Measurement',
    description: 'Generate distance in miles'
  },
  {
    name: 'unit_weight_metric',
    reference: 'mock.unit_weight_metric',
    category: 'mock',
    subCategory: 'Units of Measurement',
    description: 'Generate weight in kilograms'
  },
  {
    name: 'unit_weight_imperial',
    reference: 'mock.unit_weight_imperial',
    category: 'mock',
    subCategory: 'Units of Measurement',
    description: 'Generate weight in pounds'
  },
  {
    name: 'unit_temperature_celsius',
    reference: 'mock.unit_temperature_celsius',
    category: 'mock',
    subCategory: 'Units of Measurement',
    description: 'Generate temperature in Celsius'
  },
  {
    name: 'unit_temperature_fahrenheit',
    reference: 'mock.unit_temperature_fahrenheit',
    category: 'mock',
    subCategory: 'Units of Measurement',
    description: 'Generate temperature in Fahrenheit'
  },
  {
    name: 'unit_volume_metric',
    reference: 'mock.unit_volume_metric',
    category: 'mock',
    subCategory: 'Units of Measurement',
    description: 'Generate volume in liters'
  },
  {
    name: 'unit_volume_imperial',
    reference: 'mock.unit_volume_imperial',
    category: 'mock',
    subCategory: 'Units of Measurement',
    description: 'Generate volume in gallons'
  },
  {
    name: 'unit_speed_metric',
    reference: 'mock.unit_speed_metric',
    category: 'mock',
    subCategory: 'Units of Measurement',
    description: 'Generate speed in km/h'
  },
  {
    name: 'unit_speed_imperial',
    reference: 'mock.unit_speed_imperial',
    category: 'mock',
    subCategory: 'Units of Measurement',
    description: 'Generate speed in mph'
  },

  // ─── Country Codes & Information ───────────────────────────────────
  {
    name: 'country_code_alpha2',
    reference: 'mock.country_code_alpha2',
    category: 'mock',
    subCategory: 'Country Codes & Information',
    description: 'Generate ISO 3166-1 alpha-2 code'
  },
  {
    name: 'country_code_alpha3',
    reference: 'mock.country_code_alpha3',
    category: 'mock',
    subCategory: 'Country Codes & Information',
    description: 'Generate ISO 3166-1 alpha-3 code'
  },
  {
    name: 'country_calling_code_za',
    reference: 'mock.country_calling_code_za',
    category: 'mock',
    subCategory: 'Country Codes & Information',
    description: 'Return South Africa calling code (+27)'
  },
  {
    name: 'country_calling_code_us',
    reference: 'mock.country_calling_code_us',
    category: 'mock',
    subCategory: 'Country Codes & Information',
    description: 'Return USA calling code (+1)'
  },
  {
    name: 'country_calling_code_uk',
    reference: 'mock.country_calling_code_uk',
    category: 'mock',
    subCategory: 'Country Codes & Information',
    description: 'Return UK calling code (+44)'
  },
  {
    name: 'country_calling_code_au',
    reference: 'mock.country_calling_code_au',
    category: 'mock',
    subCategory: 'Country Codes & Information',
    description: 'Return Australia calling code (+61)'
  },

  // ─── Country-Specific: South Africa ────────────────────────────────
  {
    name: 'za_phone',
    reference: 'mock.za_phone',
    category: 'mock',
    subCategory: 'Country-Specific: South Africa',
    description: 'Generate South African landline number'
  },
  {
    name: 'southafrica_phone',
    reference: 'mock.southafrica_phone',
    category: 'mock',
    subCategory: 'Country-Specific: South Africa',
    description: 'Generate South African landline (alias)'
  },
  {
    name: 'za_cellphone',
    reference: 'mock.za_cellphone',
    category: 'mock',
    subCategory: 'Country-Specific: South Africa',
    description: 'Generate South African mobile number'
  },
  {
    name: 'southafrica_cellphone',
    reference: 'mock.southafrica_cellphone',
    category: 'mock',
    subCategory: 'Country-Specific: South Africa',
    description: 'Generate South African mobile (alias)'
  },
  {
    name: 'za_id',
    reference: 'mock.za_id',
    category: 'mock',
    subCategory: 'Country-Specific: South Africa',
    description: 'Generate South African ID number (with Luhn checksum)'
  },
  {
    name: 'southafrica_id',
    reference: 'mock.southafrica_id',
    category: 'mock',
    subCategory: 'Country-Specific: South Africa',
    description: 'Generate South African ID (alias)'
  },
  {
    name: 'za_company_registration',
    reference: 'mock.za_company_registration',
    category: 'mock',
    subCategory: 'Country-Specific: South Africa',
    description: 'Generate SA company registration number'
  },
  {
    name: 'southafrica_company_registration',
    reference: 'mock.southafrica_company_registration',
    category: 'mock',
    subCategory: 'Country-Specific: South Africa',
    description: 'Generate SA company registration (alias)'
  },
  {
    name: 'za_postal_code',
    reference: 'mock.za_postal_code',
    category: 'mock',
    subCategory: 'Country-Specific: South Africa',
    description: 'Generate 4-digit postal code'
  },
  {
    name: 'southafrica_postal_code',
    reference: 'mock.southafrica_postal_code',
    category: 'mock',
    subCategory: 'Country-Specific: South Africa',
    description: 'Generate postal code (alias)'
  },
  {
    name: 'za_province',
    reference: 'mock.za_province',
    category: 'mock',
    subCategory: 'Country-Specific: South Africa',
    description: 'Generate South African province name'
  },
  {
    name: 'southafrica_province',
    reference: 'mock.southafrica_province',
    category: 'mock',
    subCategory: 'Country-Specific: South Africa',
    description: 'Generate province (alias)'
  },
  {
    name: 'za_city',
    reference: 'mock.za_city',
    category: 'mock',
    subCategory: 'Country-Specific: South Africa',
    description: 'Generate South African city name'
  },
  {
    name: 'southafrica_city',
    reference: 'mock.southafrica_city',
    category: 'mock',
    subCategory: 'Country-Specific: South Africa',
    description: 'Generate city (alias)'
  },

  // ─── Country-Specific: USA ─────────────────────────────────────────
  {
    name: 'us_phone',
    reference: 'mock.us_phone',
    category: 'mock',
    subCategory: 'Country-Specific: USA',
    description: 'Generate US phone number'
  },
  {
    name: 'us_ssn',
    reference: 'mock.us_ssn',
    category: 'mock',
    subCategory: 'Country-Specific: USA',
    description: 'Generate US Social Security Number'
  },
  {
    name: 'us_zipcode',
    reference: 'mock.us_zipcode',
    category: 'mock',
    subCategory: 'Country-Specific: USA',
    description: 'Generate US ZIP code'
  },
  {
    name: 'us_state',
    reference: 'mock.us_state',
    category: 'mock',
    subCategory: 'Country-Specific: USA',
    description: 'Generate US state name'
  },

  // ─── Country-Specific: UK ──────────────────────────────────────────
  {
    name: 'uk_phone',
    reference: 'mock.uk_phone',
    category: 'mock',
    subCategory: 'Country-Specific: UK',
    description: 'Generate UK phone number'
  },
  {
    name: 'uk_postcode',
    reference: 'mock.uk_postcode',
    category: 'mock',
    subCategory: 'Country-Specific: UK',
    description: 'Generate UK postcode'
  },
  {
    name: 'uk_nino',
    reference: 'mock.uk_nino',
    category: 'mock',
    subCategory: 'Country-Specific: UK',
    description: 'Generate UK National Insurance Number'
  },

  // ─── Country-Specific: Australia ───────────────────────────────────
  {
    name: 'au_phone',
    reference: 'mock.au_phone',
    category: 'mock',
    subCategory: 'Country-Specific: Australia',
    description: 'Generate Australian phone number'
  },
  {
    name: 'au_postcode',
    reference: 'mock.au_postcode',
    category: 'mock',
    subCategory: 'Country-Specific: Australia',
    description: 'Generate Australian postcode'
  },
  {
    name: 'au_tfn',
    reference: 'mock.au_tfn',
    category: 'mock',
    subCategory: 'Country-Specific: Australia',
    description: 'Generate Australian Tax File Number'
  }
];
